import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface JobDef {
  titleKey: string;
  orgKey: string;
  periodKey: string;
  bulletKeys: string[];
}

const JOB_DEFS: JobDef[] = [
  { titleKey: 'experience.j1Title', orgKey: 'experience.j1Org', periodKey: 'experience.j1Period', bulletKeys: ['experience.j1b1', 'experience.j1b2', 'experience.j1b3'] },
  { titleKey: 'experience.j2Title', orgKey: 'experience.j2Org', periodKey: 'experience.j2Period', bulletKeys: ['experience.j2b1', 'experience.j2b2', 'experience.j2b3'] },
  { titleKey: 'experience.j3Title', orgKey: 'experience.j3Org', periodKey: 'experience.j3Period', bulletKeys: ['experience.j3b1', 'experience.j3b2', 'experience.j3b3', 'experience.j3b4'] },
  { titleKey: 'experience.j4Title', orgKey: 'experience.j4Org', periodKey: 'experience.j4Period', bulletKeys: ['experience.j4b1', 'experience.j4b2'] },
  { titleKey: 'experience.j5Title', orgKey: 'experience.j5Org', periodKey: 'experience.j5Period', bulletKeys: ['experience.j5b1', 'experience.j5b2', 'experience.j5b3', 'experience.j5b4'] },
  { titleKey: 'experience.j6Title', orgKey: 'experience.j6Org', periodKey: 'experience.j6Period', bulletKeys: ['experience.j6b1', 'experience.j6b2'] },
  { titleKey: 'experience.j7Title', orgKey: 'experience.j7Org', periodKey: 'experience.j7Period', bulletKeys: ['experience.j7b1', 'experience.j7b2'] },
  { titleKey: 'experience.j8Title', orgKey: 'experience.j8Org', periodKey: 'experience.j8Period', bulletKeys: ['experience.j8b1'] },
  { titleKey: 'experience.j9Title', orgKey: 'experience.j9Org', periodKey: 'experience.j9Period', bulletKeys: ['experience.j9b1', 'experience.j9b2', 'experience.j9b3'] },
];

export default function WorkingExperience() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="bg-canvas py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        <div className="mb-12">
          <span className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium">
            {t('experience.badge')}
          </span>
          <div className="w-10 h-px bg-sage mt-3" />
        </div>

        <div className="flex flex-col">
          {JOB_DEFS.map((job, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={job.titleKey}
                className={`border-b border-sage/10 ${idx === 0 ? 'border-t' : ''}`}
              >
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center gap-5 py-8 text-left cursor-pointer group"
                >
                  <div className="w-8 h-8 flex items-center justify-center text-sage shrink-0">
                    <i className="ri-briefcase-line text-lg" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-inter font-semibold text-sm text-charcoal leading-snug mb-1 group-hover:text-sage transition-colors duration-200">
                      {t(job.titleKey)}
                    </h3>
                    <p className="font-inter text-xs text-text-muted leading-relaxed">
                      {t(job.orgKey)}
                    </p>
                  </div>
                  <span className="font-cormorant text-sm md:text-lg font-light text-sage whitespace-nowrap shrink-0 mr-4">
                    {t(job.periodKey)}
                  </span>
                  <div
                    className="w-6 h-6 flex items-center justify-center text-sage shrink-0 transition-transform duration-300"
                    style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
                  >
                    <i className="ri-arrow-down-s-line text-lg" />
                  </div>
                </button>

                <div
                  className="overflow-hidden transition-all duration-300 ease-in-out"
                  style={{ maxHeight: isOpen ? `${job.bulletKeys.length * 60 + 40}px` : '0px' }}
                >
                  <ul className="pb-8 pl-[52px] flex flex-col gap-3">
                    {job.bulletKeys.map((key) => (
                      <li key={key} className="flex items-start gap-3">
                        <span className="mt-[5px] w-1 h-1 rounded-full bg-sage shrink-0" />
                        <p className="font-inter text-sm text-charcoal/70 leading-relaxed">{t(key)}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
